import React from 'react'
import "./Marquee.css";

function Marquee() {



  return (
    <div className='dis'>
      <div className="marquee-container">
        <div className="marquee-content">
          <span className="featured">WINNERS</span> <span className="dot">•</span> <span className="news">WILL BE FEATURED</span> <span className="dot">•</span>
          <span className="featured">ON OUR WEBSITE</span> <span className="dot">•</span>   <span className="featured">WINNERS</span> <span className="dot">•</span> <span className="news">WILL BE FEATURED</span> <span className="dot">•</span>
          <span className="featured">ON OUR WEBSITE</span> <span className="dot">•</span> <span className="featured">WINNERS</span> <span className="dot">•</span> <span className="news">WILL BE FEATURED</span> <span className="dot">•</span>
          <span className="featured">ON OUR WEBSITE</span> <span className="dot">•</span>   <span className="featured">WINNERS</span> <span className="dot">•</span> <span className="news">WILL BE FEATURED</span> <span className="dot">•</span>
          <span className="featured">ON OUR WEBSITE</span> <span className="dot">•</span>

        </div>
      </div>

      <div className="marquee-container">
        <div className="marquee-content-alt">
          <span className="featured">WINNERS</span> <span className="dot">•</span> <span className="news">WILL BE FEATURED</span> <span className="dot">•</span>
          <span className="featured">ON OUR WEBSITE</span> <span className="dot">•</span>   <span className="featured">WINNERS</span> <span className="dot">•</span> <span className="news">WILL BE FEATURED</span> <span className="dot">•</span>
          <span className="featured">ON OUR WEBSITE</span> <span className="dot">•</span> <span className="featured">WINNERS</span> <span className="dot">•</span> <span className="news">WILL BE FEATURED</span> <span className="dot">•</span>
          <span className="featured">ON OUR WEBSITE</span> <span className="dot">•</span>   <span className="featured">WINNERS</span> <span className="dot">•</span> <span className="news">WILL BE FEATURED</span> <span className="dot">•</span>
          <span className="featured">ON OUR WEBSITE</span> <span className="dot">•</span>
        </div>
      </div>

    </div>
  )
}

export default Marquee